module.exports = __webpack_public_path__ + "static/media/08.c0e81436.png";